import * as B from '@blueprintjs/core';
import React from 'react';

import cs from './styles.module.scss';

export const CollapsibleImpactCallout: React.FunctionComponent<
  React.PropsWithChildren<{
    intent: B.Intent;
    title: string;
    summary: React.ReactNode;
  }>
> = ({intent, title, summary, children}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <B.Callout intent={intent}>
      <div className={cs.collapsibleCalloutHeader}>
        <div>
          <strong>{title}:</strong> {summary}
        </div>
        <B.Button
          minimal
          small
          rightIcon={isOpen ? 'chevron-up' : 'chevron-down'}
          text={isOpen ? 'Hide details' : 'Show details'}
          onClick={() => setIsOpen((open) => !open)}
        />
      </div>
      <B.Collapse isOpen={isOpen}>{children}</B.Collapse>
    </B.Callout>
  );
};
